.layout {
  min-height: 100vh;
}

/* 加上 .layout 前缀，优先级高于 antd 组件自身的样式 */
.layout .header {
  position: sticky;
  top: 0;
  z-index: 100;
  height: 64px;
  line-height: normal;
  border-bottom: 1px solid var(--ant-color-border-secondary);
}

.layout .sider {
  position: sticky;
  top: 64px;
  height: calc(100vh - 64px);
  overflow: hidden auto;
  border-right: 1px solid var(--ant-color-border-secondary);
}

.layout .content {
  min-width: 0;
  padding: 24px;
}
